import { useState } from 'react';
import { CheckAuth } from 'pages/auth/actions.js';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import OPWBreadcrumb from 'components/breadcrumb.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AnimalAgeSelect } from 'components/animalAgeSelect.js';
import { TimezoneSelect } from 'components/timezones/timezoneSelect.js';
import { AnimalSizeSelect } from 'components/animalSizeSelect.js';
import { AnimalGenderSelect } from 'components/animalGenderSelect.js';
import { BreedTypeSelect } from 'components/breedTypeSelect.js';
import { WoolGrowthSelect } from 'components/woolGrowthSelect.js';
import GenericModal from 'components/genericModal.js';
import {
	SessionName,
	SessionEndDate,
	HeadCount,
	PaddockSize,
	Attractant,
	DisplayUnits,
} from './controls.js';

//const TITLE = 'Session Management'
const BC = OPWBreadcrumb;

export const SessionDetail = (props) => {
	return (
		<>
			<CheckAuth groupName={'admin'} />
			<Header>
				<BC
					trail={
						'[["Home", "/"], ["Session management", "/manage/session"], ["' +
						(props.values.SessionName || 'New session') +
						'", ""]]'
					}
				/>
			</Header>
			<Container fluid className="body">
				<Form onSubmit={props.handleSubmit}>
					<SessionDetailControls {...props} />
					<br />
				</Form>
			</Container>
			<Container fluid>
				<Row>
					<Col sm="12">
						<Footer />
					</Col>
				</Row>
			</Container>
		</>
	);
};

const Controls = (props) => {
	const {
		setSessionDetailShow,
		modified,
		setModified,
		valMsg,
		addingNewSession,
		setAddingNewSession,
	} = props;

	const msg = valMsg ? `Warning: ${valMsg}. Fix and try again.` : '';
	//const disableControl = (addingNewSession || weigherId === null || weigherId === undefined)
	const title = modified
		? 'click to save changes'
		: 'locked - no data modified';

	const handleExit = () => {
		if (addingNewSession) {
			setAddingNewSession(false);
		}
		setSessionDetailShow(false);
	};

	const handleSave = (e) => {
		setModified(false);
		props.handleSubmit(e);
		//aButton.setState({disabled: true});
	};

	return (
		<div className="formButtons">
			<p className={'validationError' + (msg === '' ? ' hidden' : '')}>{msg}</p>
			<ButtonGroup>
				{/* <Button
					variant="info"
					onClick={() => setSessionChangeModalShow(true)}
					{ ...(disableControl && { disabled: true }) }
				>{ modalBtnDesc }</Button> */}
				<Button
					type="submit"
					variant="outline-primary"
					title={title}
					{...(!modified && { disabled: true })}
					{...(!modified && { variant: 'outline-secondary' })}
					onClick={(e) => handleSave(e)}
				>
					Save changes
				</Button>
				<Button variant="outline-primary" onClick={() => handleExit()}>
					Exit without saving
				</Button>
				{/* <Link to = "/"><Button variant="info" { ...(!modified && { disabled: true }) }>Exit without saving</Button></Link> */}
			</ButtonGroup>
		</div>
	);
};

/**
 * This is all the detail form controls for setting data in a session
 * @param {} props
 */
export const SessionDetailControls = (props) => {
	const {
		cols,
		controlStyle,
		handleChange,
		values,
		defaultTimezone,
		addingNewSession,
		modalExitWithoutSavingShow,
		setModalExitWithoutSavingShow,
		modalExitWithoutSavingData,
		handleModalExitWithoutSaving,
		handleSessionStartObjChange,
		handleSessionEndObjChange,
		species,
		//weigherId,
	} = props;
	const [more, set_more] = useState(false);

	return (
		<>
			<Row>
				<Col>
					<Card body>
						<Card.Title>{values.SessionName || 'New session'}</Card.Title>
						<Card.Body>
							<SessionName
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.SessionName || ''}
							/>
							<TimezoneSelect
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.timezone || defaultTimezone}
							/>

							<Row className="inputRow">
								<Col sm={cols.lhs}>Session start:</Col>
								<Col sm={cols.rhs}>
									<DatePicker
										//id = 'sessionStartObj'
										className={'datepickerxx form-control'}
										//className = { 'datepicker' }
										dateFormat={'dd MMM yyyy HH:mm'}
										selected={values.sessionStartObj || new Date()}
										showTimeSelect
										todayButton={'Now'}
										timeIntervals={15}
										scrollableYearDropdown={true}
										showYearDropdown={true}
										onChange={(dateObj) => handleSessionStartObjChange(dateObj)}
										style={controlStyle}
									/>
								</Col>
							</Row>
							{!addingNewSession && (
								<SessionEndDate
									cols={cols}
									value={values.sessionEndObj}
									handleSessionEndObjChange={handleSessionEndObjChange}
									//controlStyle = {{...{width: '15em'},...controlStyle}}
									controlStyle={controlStyle}
								/>
							)}

							<HeadCount
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={handleChange}
								value={values.Head || ''}
							/>
							<BreedTypeSelect
								cols={cols}
								controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.BreedType || ''}
								species={species}
							/>
							<AnimalGenderSelect
								cols={cols}
								controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.Sex || ''}
								species={species}
							/>
							<AnimalAgeSelect
								cols={cols}
								controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.Age || ''}
								species={species}
							/>
							<WoolGrowthSelect
								cols={cols}
								controlStyle={{ ...{ width: '15em' }, ...controlStyle }}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.WoolGrowth || ''}
								species={species}
							/>
							<PaddockSize
								cols={cols}
								controlStyle={controlStyle}
								required={true}
								handleChange={(evt) => handleChange(evt)}
								value={values.Paddock || ''}
								readOnly={true}
							/>
							<Row className="inputRow">
								<Col sm={cols.lhs}>
									<Button
										variant="link"
										checked={more}
										onClick={() => set_more(!more)}
									>
										{more ? '- Show less' : '+ Show more'}
									</Button>
								</Col>
							</Row>
							{more && (
								<>
									<DisplayUnits
										cols={cols}
										controlStyle={controlStyle}
										value={values.displayUnits}
										handleChange={handleChange}
									/>
								</>
							)}
							<GenericModal
								title="Exit without saving?"
								bodyTxt="You are changing sessions with changes without saving!"
								show={modalExitWithoutSavingShow}
								setShow={setModalExitWithoutSavingShow}
								buttons={[
									{ desc: 'Exit without saving changes', id: 'loseChangesBtn' },
									{ desc: 'Cancel', id: 'cancelExitBtn' },
								]}
								data={modalExitWithoutSavingData || {}}
								handleButton={(data) => handleModalExitWithoutSaving(data)}
							/>

							<Controls {...props} />
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
};
